import { render } from "./EncuestaEditar.vue?vue&type=template&id=135d188c"
import script from "./EncuestaEditar.vue?vue&type=script&lang=js"
export * from "./EncuestaEditar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__